// extracted by mini-css-extract-plugin
export var wordContainer = "_mt-0";